import axios from "axios";
import apiClient from "./axiosConfig";

export async function resolve(promise) {
  try {
    const data = await promise;
    return { data: data.data, error: null };
  } catch (e) {
    return {
      data: null,
      error: e.response ? e.response.data : e.message,
    };
  }
}

export async function sentDetails(data) {
  const form = {
    parentName: data.name,
    childAge: data.service,
    phoneNumber: data.phone,
    message: data.message,
    emailAddress: data.email,
  };
  const response = await axios.post(
    `https://api-v2.socialspectrum.org/api/website/contact-us`,
    form,
    { headers: { "Content-Type": "application/json" } },
  );
  return response.data;
}

export async function sentNewsletter(data) {
  const form = {
    email: data.email,
  };
  const response = await axios.post(
    `https://api-v2.socialspectrum.org/api/website/news-letter`,
    form,
    { headers: { "Content-Type": "application/json" } },
  );
  return response.data;
}

export const GetAllNewsLetters = () =>
  axios.get(`https://api-v2.socialspectrum.org/api/website/newsletter`);

export const GetAllBlogs = () =>
  axios.get(`https://api-v2.socialspectrum.org/api/website/get_blog`);
export const GetSearchBlogs = (text) =>
  axios.get(
    `https://api-v2.socialspectrum.org/api/website/get_blog/?search_text=${text}`,
  );
export const GetOneBlog = (id) =>
  axios.get(`https://api-v2.socialspectrum.org/api/website/blog/${id}`);

export const CreateComment = (data, id) =>
  axios.post(
    `https://api-v2.socialspectrum.org/api/website/comments/blog/${id}`,
    data,
  );

export const GetAllEvents = () =>
  axios.get(`https://api-v2.socialspectrum.org/api/website/marketing-events`);

export const GetAllTestimonials = () =>
  axios.get(`https://api-v2.socialspectrum.org/api/website/testimonial`);

export const CreateTestimonial = (data) =>
  axios.post(
    `https://api-v2.socialspectrum.org/api/website/testimonial/create`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

export const DownloadInfographic = (data) =>
  apiClient.post(
    `https://api-v2.socialspectrum.org/api/website/wb-infographic`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

export const DeleteAccount = (data) =>
  apiClient.post(
    `https://api-v2.socialspectrum.org/api/website//delete-account`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
